<div class="ccd-dialog">
  <!-- Header -->
  <div class="ccd-header">
    <div class="ccd-header-left">
      <div class="ccd-header-icon">
        <mat-icon>groups</mat-icon>
      </div>
      <div>
        <h5 class="ccd-title">{{ isEdit ? 'Edit Custom Department' : 'Create Custom Department' }}</h5>
        <!-- <p class="ccd-subtitle">Department Name</p> -->
      </div>
    </div>
    <button type="button" class="ccd-close" (click)="close()" title="Close">✕</button>
  </div>

  <!-- Custom name -->
  <div class="ccd-field">
    <label class="ccd-label">Department Name <span class="ccd-req">*</span></label>
    <input
      type="text"
      class="ccd-input"
      [class.invalid]="hasDuplicateDepartmentName || hasDepartmentNameMaxLengthError"
      placeholder="Please Enter Department Name..."
      [attr.maxlength]="maxDepartmentNameLength"
      [(ngModel)]="customName"
      (ngModelChange)="onDepartmentNameChange($event)"
      (keydown)="onDepartmentNameKeydown($event)"
      (paste)="onDepartmentNamePaste($event)"
    />
  </div>

  <div class="ccd-error" *ngIf="hasDepartmentNameMaxLengthError">
    <mat-icon>error_outline</mat-icon>
    <span>Department name can be up to 100 characters only.</span>
  </div>

  <div class="ccd-error" *ngIf="hasDuplicateDepartmentName">
    <mat-icon>error_outline</mat-icon>
    <span>This department name already exists.</span>
  </div>

  <!-- Search (Team Members / Departments) -->
  <div class="ccd-field">
    <div class="ccd-search-head">
      <label class="ccd-label">Add Members <span class="ccd-req">*</span></label>
      <div class="ccd-segment" role="tablist" aria-label="Search mode">
        <button
          type="button"
          class="ccd-seg-btn"
          role="tab"
          [class.active]="searchMode === 'members'"
          [attr.aria-selected]="searchMode === 'members'"
          (click)="setSearchMode('members')"
        >
          <mat-icon>person</mat-icon>
          <span>Team Members</span>
        </button>
        <button
          type="button"
          class="ccd-seg-btn"
          role="tab"
          [class.active]="searchMode === 'departments'"
          [attr.aria-selected]="searchMode === 'departments'"
          (click)="setSearchMode('departments')"
        >
          <mat-icon>apartment</mat-icon>
          <span>Departments</span>
        </button>
      </div>
    </div>

    <!-- Member search -->
    <div class="ccd-search" *ngIf="searchMode === 'members'">
      <mat-icon class="ccd-search-icon">search</mat-icon>
      <input
        type="text"
        class="ccd-search-input"
        placeholder="Search by team member name and email address..."
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchInput()"
      />
      <button *ngIf="searchText" type="button" class="ccd-search-clear" (click)="clearSearch()" title="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Department search -->
    <div class="ccd-search" *ngIf="searchMode === 'departments'">
      <mat-icon class="ccd-search-icon">search</mat-icon>
      <input
        type="text"
        class="ccd-search-input"
        placeholder="Search departments by name..."
        [(ngModel)]="deptSearchText"
        (ngModelChange)="onDeptSearchInput()"
      />
      <button *ngIf="deptSearchText" type="button" class="ccd-search-clear" (click)="clearDeptSearch()" title="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Results -->
  <div class="ccd-list" (scroll)="onDeptListScroll($event)">
    <!-- Team member results -->
    <ng-container *ngIf="searchMode === 'members'">
      <div *ngIf="isSearching" class="ccd-state">
        <div class="ccd-spinner"></div>
        <span>Searching team members...</span>
      </div>

      <ng-container *ngIf="!isSearching">
        <div
          class="ccd-item"
          *ngFor="let item of results; trackBy: trackByMemberId"
          [class.selected]="isSelected(item)"
          (click)="toggleMember(item)"
          role="button"
        >
          <span class="ccd-checkbox" [class.checked]="isSelected(item)">
            <mat-icon *ngIf="isSelected(item)">check</mat-icon>
          </span>
          <div class="ccd-avatar">{{ getInitials(item.name) }}</div>
          <div class="ccd-item-body">
            <div class="ccd-item-name">{{ item.name || 'Unknown' }}</div>
            <div class="ccd-item-sub" *ngIf="item.email || item.department">
              <span *ngIf="item.email">{{ item.email }}</span>
              <span *ngIf="item.department" class="ccd-item-dept">{{ item.department }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="hasSearched && results.length === 0" class="ccd-state">
          <mat-icon>person_search</mat-icon>
          <span>No team members found for "{{ searchText }}".</span>
        </div>

        <div *ngIf="!hasSearched && results.length === 0" class="ccd-state">
          <mat-icon>search</mat-icon>
          <span>Start typing to search team members by name and email address...</span>
        </div>
      </ng-container>
    </ng-container>

    <!-- Department results -->
    <ng-container *ngIf="searchMode === 'departments'">
      <!-- <div *ngIf="isDeptLoading" class="ccd-state">
        <div class="ccd-spinner"></div>
        <span>Loading departments...</span>
      </div> -->

      <ng-container *ngIf="!isDeptLoading">
        <div class="ccd-dept-group" *ngFor="let dept of deptResults; trackBy: trackByDeptId">
          <div
            class="ccd-item"
            [class.selected]="isDeptSelected(dept)"
            (click)="toggleDepartment(dept)"
            role="button"
          >
            <span class="ccd-checkbox" [class.checked]="isDeptSelected(dept)">
              <mat-icon *ngIf="isDeptSelected(dept)">check</mat-icon>
            </span>
            <div class="ccd-dept-avatar"><mat-icon>apartment</mat-icon></div>
            <div class="ccd-item-body">
              <div class="ccd-item-name">{{ dept.name }}</div>
              <div class="ccd-item-sub">
                <span>{{ dept.count }} {{ dept.count === 1 ? 'member' : 'members' }}</span>
              </div>
            </div>
            <div class="ccd-mini-spinner" *ngIf="isDeptLoadingMembers(dept)"></div>
            <ng-container *ngIf="!isDeptLoadingMembers(dept)">
              <ng-container *ngIf="getSelectedMemberCount(dept) as selectedCount">
                <span class="ccd-item-count" [class.full]="isDeptSelected(dept)">{{ selectedCount }} selected</span>
              </ng-container>
            </ng-container>
            <button
              type="button"
              class="ccd-dept-expand"
              (click)="$event.stopPropagation(); toggleDeptExpand(dept)"
              [attr.aria-expanded]="isDeptExpanded(dept)"
              [title]="isDeptExpanded(dept) ? 'Hide members' : 'Show members'"
            >
              <mat-icon [class.open]="isDeptExpanded(dept)">expand_more</mat-icon>
            </button>
          </div>

          <!-- Department members (individual selection) -->
          <div class="ccd-dept-members" *ngIf="isDeptExpanded(dept)">
            <div *ngIf="isDeptLoadingMembers(dept) && getDeptMembers(dept).length === 0" class="ccd-state ccd-state-sm">
              <div class="ccd-spinner"></div>
              <span>Loading members...</span>
            </div>

            <div
              class="ccd-item ccd-item-member"
              *ngFor="let member of getDeptMembers(dept); trackBy: trackByMemberId"
              [class.selected]="isSelected(member)"
              (click)="toggleMember(member)"
              role="button"
            >
              <span class="ccd-checkbox" [class.checked]="isSelected(member)">
                <mat-icon *ngIf="isSelected(member)">check</mat-icon>
              </span>
              <div class="ccd-avatar">{{ getInitials(member.name) }}</div>
              <div class="ccd-item-body">
                <div class="ccd-item-name">{{ member.name || 'Unknown' }}</div>
                <div class="ccd-item-sub" *ngIf="member.email">
                  <span>{{ member.email }}</span>
                </div>
              </div>
            </div>

            <div *ngIf="!isDeptLoadingMembers(dept) && getDeptMembers(dept).length === 0" class="ccd-state ccd-state-sm">
              <mat-icon>person_off</mat-icon>
              <span>No members in this department.</span>
            </div>
          </div>
        </div>

        <div *ngIf="deptResults.length === 0 && deptSearchText" class="ccd-state">
          <mat-icon>domain_disabled</mat-icon>
          <span>No departments found for "{{ deptSearchText }}".</span>
        </div>

        <div *ngIf="deptResults.length === 0 && !deptSearchText" class="ccd-state">
          <mat-icon>apartment</mat-icon>
          <span>No departments available.</span>
        </div>

        <div *ngIf="isDeptLoadingMore && deptResults.length > 0" class="ccd-state ccd-state-sm">
          <div class="ccd-spinner"></div>
          <span>Loading more departments...</span>
        </div>

        <div *ngIf="allDeptsLoaded && deptResults.length > 0" class="ccd-state ccd-state-sm">
          <span>All departments loaded</span>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- Selected departments -->
  <div class="ccd-selected" *ngIf="selectedDepartments.length > 0">
    <div class="ccd-selected-head">
      <span>Selected departments</span>
      <span class="ccd-count ccd-count-dept">{{ selectedDepartments.length }}</span>
    </div>
    <div class="ccd-chips">
      <span class="ccd-chip ccd-chip-dept" *ngFor="let dept of selectedDepartments; trackBy: trackByDeptId">
        <mat-icon class="ccd-chip-ic">apartment</mat-icon>
        <span class="ccd-chip-label">{{ dept.name }}</span>
        <button type="button" class="ccd-chip-remove" (click)="removeDepartment(dept)" title="Remove">✕</button>
      </span>
    </div>
  </div>

  <!-- Selected members -->
  <div class="ccd-selected" *ngIf="selectedMembers.length > 0">
    <div class="ccd-selected-head">
      <span>Selected members</span>
      <span class="ccd-count">{{ selectedMembers.length }}</span>
    </div>
    <div class="ccd-chips">
      <span class="ccd-chip" *ngFor="let item of selectedMembers; trackBy: trackByMemberId">
        <span class="ccd-chip-label">{{ item.name || item.email }}</span>
        <button type="button" class="ccd-chip-remove" (click)="removeSelected(item)" title="Remove">✕</button>
      </span>
    </div>
  </div>

  <!-- Footer -->
  <div class="ccd-footer">
    <button type="button" class="ccd-btn ccd-btn-cancel" (click)="close()" [disabled]="isSaving">Cancel</button>
    <button type="button" class="ccd-btn ccd-btn-save" [disabled]="!canSave || isSaving" (click)="save()">
      <span *ngIf="!isSaving">{{ isEdit ? 'Update' : 'Save' }}<span *ngIf="selectedMembers.length > 0"> ({{ selectedMembers.length }})</span></span>
      <span *ngIf="isSaving">Saving…</span>
    </button>
  </div>
</div>
